import React, { createContext } from 'react';
import omit from 'lodash/omit';
import identity from 'lodash/identity';
import PropTypes from 'prop-types';
import * as enJson from './en.json';
import * as frJson from './fr.json';

const Context = createContext(identity);

export const Translate = Context.Consumer;

export const withTranslation = () => (WrappedComponent) => {
  const ComponentWithTranslation = ({ ...props }) => (
    <Translate>
      {translate => <WrappedComponent t={translate} {...props} />}
    </Translate>
  );

  ComponentWithTranslation.propTypes = {
    ...omit(WrappedComponent.propTypes, 't'),
  };

  ComponentWithTranslation.defaultProps = {
    ...WrappedComponent.defaultProps,
  };

  return ComponentWithTranslation;
};

export const TranslationProvider = ({ children, translate }) => (
  <Context.Provider value={translate}>
    {children}
  </Context.Provider>
);

TranslationProvider.propTypes = {
  children: PropTypes.any.isRequired,
  translate: PropTypes.func.isRequired,
};

export const translationTexts = {
  en: enJson,
  fr: frJson,
};
